import React, { useRef } from 'react';
import {
    Row,
    Col,
    Divider,
    Input,
    Typography,
    Form,
    Button,
    Checkbox,
    Statistic,
    Skeleton,
    Result
} from 'antd';
import {
    FaPrint
} from "react-icons/fa";
import { useParams } from 'react-router-dom';
import {
    useQuery,
} from '@tanstack/react-query';
import { useReactToPrint } from 'react-to-print';
// import axios from '../../config/axios';
import dayjs from 'dayjs';
import OrderItemsDetail from './components/OrderItemsDetail';
import Invoice from '../../components/Invoice';
import CancelOrder from './components/CancelOrder';

function Detail() {

    const { orderId } = useParams();
    const [form] = Form.useForm();
    const componentRef = useRef();
    const orderQuery = useQuery({ queryKey: [`/api/orders/${orderId}`] });
    const orderItemsQuery = useQuery({ queryKey: [`/api/orderItems/getOrderDetail/${orderId}`] });

    const onPrint = useReactToPrint({
        content: () => componentRef.current,
        documentTitle: orderQuery?.data?.order_no
    });

    if (
        orderItemsQuery.isLoading
        || orderQuery.isLoading
    ) {
        return <Skeleton active />
    }

    if (
        orderItemsQuery.isError
        || orderQuery.isError
    ) {
        return <Result
            status="error"
            title={
                orderItemsQuery.error.message
                || orderQuery.error.message
            } />
    };

    // console.log('orderQuery.data =', orderQuery.data);
    return (
        <div style={{
            background: '#fff',
        }}>
            <Row justify='space-between' gutter={[16, 16]}>
                <Col xs={24}>
                    <Row justify='space-between'>
                        <Col xs={24}>
                            <Typography.Title level={3}>
                                OrderNo. {orderQuery.data.order_no}
                            </Typography.Title>
                        </Col>
                        <Col xs={24}>
                            <Typography.Title level={5}>
                                วันที่ {dayjs(orderQuery.data.order_date).format('DD-MM-YYYY')}
                            </Typography.Title>
                        </Col>
                    </Row>
                </Col>
                <Col xs={24}>
                    <Form
                        name="createUser"
                        layout="vertical"
                        form={form}
                        initialValues={{
                            ...orderQuery.data,
                            fname_th: orderQuery.data.student?.fname_th,
                            lname_th: orderQuery.data.student?.lname_th,
                            phone: orderQuery.data.student?.phone,
                            parent_phone: orderQuery.data.student?.parent?.phone,
                            // order_date: dayjs(orderQuery.data.order_date).isValid() ? dayjs(orderQuery.data.order_date) : null
                        }}
                    >
                        <Row>
                            <Col xs={24} md={16}>
                                <Row gutter={[8, 8]}>
                                    {/* <Col xs={24} md={12}>
                                        <Form.Item
                                            label="Date"
                                            name="order_date"
                                        >
                                            <DatePicker style={{ width: "100%" }} format={'DD-MM-YYYY'} />
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} md={12}></Col> */}
                                    <Col xs={24} md={12}>
                                        <Form.Item
                                            label="First Name (ภาษาไทย)"
                                            name="fname_th"
                                        >
                                            <Input />
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} md={12}>
                                        <Form.Item
                                            label="Last Name (Thai)"
                                            name="lname_th"
                                        >
                                            <Input />
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} md={12}>
                                        <Form.Item
                                            label="Phone Number"
                                            name="phone"
                                        >
                                            <Input />
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} md={12}>
                                        <Form.Item
                                            label="Parent Phone"
                                            name="parent_phone"
                                        >
                                            <Input />
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} md={12}>
                                        <Form.Item
                                            label="Payment Type"
                                            name="payment_type"
                                        >
                                            <Input />
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} md={12}>
                                        <Form.Item
                                            label="Vat. Include"
                                            name="is_vat"
                                            valuePropName="checked"
                                        >
                                            <Checkbox />
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24}>
                                        <Form.Item
                                            label="Description"
                                            name="description"
                                        >
                                            <Input.TextArea rows={4} />
                                        </Form.Item>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </Form>
                </Col>
                <Col xs={24} md={16}>
                    <OrderItemsDetail orderItems={orderItemsQuery.data} />
                </Col>

                <Col xs={24} md={16}>
                    <Form form={form}>
                        <Row gutter={[8, 8]}>
                            <Col xs={24}>
                                <Row justify="end">
                                    <Col>
                                        <Typography.Paragraph style={{ margin: '0px 24px 0px 0px', padding: '0px' }}>ราคาสินค้าไม่รวม Vat (บาท) :</Typography.Paragraph>
                                    </Col>
                                    <Col >
                                        <Form.Item shouldUpdate>
                                            {() => {
                                                return <Statistic
                                                    value={form.getFieldValue('total').toFixed(2)}
                                                    precision={2}
                                                    valueStyle={{ fontSize: '14px', textAlign: 'end' }}
                                                />
                                            }}
                                        </Form.Item>
                                    </Col>
                                </Row>
                            </Col>
                            <Col xs={24}>
                                <Row justify="end">
                                    <Col>
                                        <Typography.Paragraph style={{ margin: '0px 24px 0px 0px', padding: '0px' }}>ภาษีมูลค่าเพิ่ม 7% Vat (บาท):</Typography.Paragraph>
                                    </Col>
                                    <Col >
                                        <Form.Item shouldUpdate>
                                            {() => {
                                                return <Statistic
                                                    value={form.getFieldValue('vat').toFixed(2)}
                                                    precision={2}
                                                    valueStyle={{ fontSize: '14px', textAlign: 'end' }}
                                                />
                                            }}
                                        </Form.Item>
                                    </Col>
                                </Row>
                            </Col>
                            <Col xs={24}>
                                <Row justify="end">
                                    <Col>
                                        <Typography.Title level={5} style={{ margin: '0px 24px 0px 0px', padding: '0px' }}>ราคารวมสุทธิทั้งหมด(บาท) :</Typography.Title>
                                    </Col>
                                    <Col >
                                        <Form.Item shouldUpdate>
                                            {() => {
                                                return <Statistic
                                                    value={form.getFieldValue('grand_total')}
                                                    precision={2}
                                                    valueStyle={{ fontSize: '16px', textAlign: 'end', fontWeight: 600 }}
                                                />
                                            }}
                                        </Form.Item>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </Form>
                </Col>
                <Col xs={24} md={16}>
                    <Divider />
                </Col>
                <Col xs={24} md={16}>
                    <Row justify='end' gutter={[8, 8]}>
                        <Col>
                            <CancelOrder order={orderQuery.data} />
                        </Col>
                        <Col>
                            <Button
                                type="primary"
                                icon={<FaPrint />}
                                onClick={onPrint}
                                style={{
                                    width: '100%',
                                    textTransform: 'capitalize'
                                }}
                            >
                                print
                            </Button>
                        </Col>
                    </Row>

                </Col>
            </Row>
            <div style={{ display: "none" }}>
                <Invoice orderData={orderQuery.data} orderItems={orderItemsQuery.data} printRef={componentRef} />
            </div>
        </div>
    )
}

export default Detail